import React from 'react';
import { CTABlock } from './CTABlock';
export function EmotionalClose() {
  return <section className="bg-forest-900 text-forest-50 py-24 px-4" data-id="element-16">
      <div className="max-w-3xl mx-auto text-center space-y-8 text-lg md:text-xl leading-relaxed" data-id="element-17">
        <p className="text-2xl md:text-3xl font-bold" data-id="element-18">
          🌿 Tu intestino no está roto
        </p>

        <p data-id="element-19">Solo está esperando que le des el mapa correcto.</p>

        <p data-id="element-20">
          Necesitás un sistema que entienda tu biología, tu país y tu realidad.
        </p>

        <div className="pt-4" data-id="element-21">
          <CTABlock className="w-full md:w-auto text-lg md:text-xl" data-id="element-22">
            ACCEDÉ AHORA AL SISTEMA COMPLETO
          </CTABlock>
        </div>
      </div>
    </section>;
}